import axios from "axios";
import { signupSubmitURL } from "../utils/constants";
import {
    signupSubmitStart,
    signupSubmitSuccess,
    signupSubmitError,
} from "../actions/signupActions";

const signupSubmit = async (params, dispatch) => {
    dispatch(signupSubmitStart());
    try {
        const result = await axios.post(signupSubmitURL, params);
        dispatch(signupSubmitSuccess());
        return result;
    } catch (error) {
        let errorMsg;
        if (error.response) {
            //The request was made and server responded
            errorMsg = error.response.data;
        } else {
            //Error happened during setting up the request
            errorMsg = error.message;
        }
        dispatch(signupSubmitError(errorMsg || "signup.error.unknown_error"));
        console.log(error);
    }
};

export { signupSubmit };
